import type { InventoryLevel } from '@interfaces/ILogistics';
import { levelCells, rowTone } from './logistics.format';
import styles from './ReorderTickTank.module.css';

interface IReorderTickTankProps {
  level: InventoryLevel;
  /** Project timezone — `rowTone` measures "overdue" against the site's today. */
  tz: string;
  /** Extra class on the tank, for surface-specific layout (e.g. `align-self`). */
  className?: string;
}

/**
 * The 10-cell stock gauge.
 *
 * Rendered by the Logistics inventory row (`InventoryRow`), its only caller
 * today. It stays a standalone component — with a `className` seam for
 * surface-specific layout — because the markup and CSS were once copy-pasted
 * across two surfaces and kept in lockstep by hand. `needsCheck` rows have a
 * dead estimate and render no gauge.
 */
export function ReorderTickTank({ level, tz, className }: IReorderTickTankProps) {
  if (level.needsCheck) return null;

  const solid = levelCells(level);

  return (
    <span
      className={className ? `${styles.tank} ${className}` : styles.tank}
      data-tone={rowTone(level, tz)}
      aria-hidden="true"
    >
      {Array.from({ length: 10 }, (_, i) => (
        <span key={i} className={i < solid ? styles.cellSolid : styles.cellSpent} />
      ))}
    </span>
  );
}
